import request from '@/utils/request'

export function uploadUserImg (params) {
    return request({
        url: '/v2/userImg/uploadUserImg',
        method: 'post',
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        },
        data: params
    })
 }

 export function deleteUserImg (params) {
    return request({
        url: '/v2/userImg/deleteUserImg',
        method: 'post',
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        },
        data: params
    })
  }
 
 export function getUserImgList (params) {
    return request({
        url: '/v2/userImg/getUserImgList',
        method: 'post',
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        },
        data: params
    })
 }